import React, { useState, useEffect } from 'react';
import Form from '../../np-form/Form';
import { withStyles } from '@material-ui/core';
import * as formUtility from '../../np-form/utility';
import makeAnimated from 'react-select/animated';
import moment from 'moment/moment.js';

const animatedComponents = makeAnimated();


const styles = theme => ({

    validMessage: {
        marginTop: '4px',
        marginBottom: '6%',
    },
    date: {
        marginBottom: '6%',
        width: '100%',
        marginTop: '4px'
    },
    form: {
        width: '92%',
        marginLeft: '15px',
        marginTop: '1px',
    }
});
const updateFormStateOne = (classes, data, activeCustomer, loading, translations) => {
    const form = {
        CustomerIDs: {
            elementType: 'multi-select',
            elementConfig: {
                type: 'multi-select',
                isMulti: true,
                closeMenuOnSelect: false,
                components: animatedComponents,
                name: 'Customer',
                className: classes.validMessage,
                label: translations['choose_customer'] || 'Choose customer',
                options: data.customer,
                isLoading: loading,

                selected: [activeCustomer],
                margin: "dense",
                fullWidth: true,
            },
            value: [activeCustomer],
            formHelperText: translations['choose_customer'] || 'Choose customer:',
            validation: {
                required: true
            },
            valid: true,
            touched: true

        },
        from: {

            elementType: 'datePickerTheme',
            elementConfig: {
                type: 'datePicker',
                margin: "dense",
                inputVariant: "outlined",
                fullWidth: false,
                placeholder: translations['report_from_label'] || 'Please select valid from date',
                disabled: false,
                className: classes.date,
                disableFuture: true,
            },
            value: moment().subtract(7, 'days').startOf('day'),
            formHelperText: `${translations['from'] || 'From'}:`,

            validation: {
                required: true
            },
            valid: true,
            touched: true

        },
        to: {
            elementType: 'datePickerTheme',
            elementConfig: {
                type: 'datePicker',
                className: classes.date,
                inputVariant: "outlined",
                margin: "dense",
                minDate: moment().subtract(7, 'days').startOf('day'),
                fullWidth: false,
                placeholder: translations['report_to_label'] || 'Please select valid to date',
                disabled: false
            },
            value: moment(),
            formHelperText: `${translations['to'] || 'To'}:`,

            validation: {
                required: true
            },
            valid: true,
            touched: true
        },
        OrderIDs: {
            elementType: 'multi-select',
            elementConfig: {
                type: 'multi-select',
                isMulti: true,
                closeMenuOnSelect: false,
                components: animatedComponents,
                name: 'Order',
                className: classes.validMessage,
                isLoading: loading,
                label: translations['choose_order'] || 'Choose order',
                options: data.order,
                selected: [],
                margin: "dense",
                fullWidth: true,
            },
            formHelperText: translations['choose_order'] || ' Choose order:',
            value: [],
            validation: {
                required: true
            },
            valid: true,
            touched: true
        },
        TransportColliIDs: {
            elementType: 'multi-select',
            elementConfig: {
                type: 'multi-select',
                isMulti: true,
                className: classes.validMessage,
                closeMenuOnSelect: false,
                components: animatedComponents,
                isLoading: loading,
                name: 'TransportCollies',
                label: translations['choose_transport_collies'] || 'Choose transport collies',
                options: data.transportCollie,
                selected: [],
                margin: "dense",
                fullWidth: true,
            },
            formHelperText: translations['choose_transport_collies'] || 'Choose transport collies:',
            value: [],
            validation: {
                required: true
            },
            valid: true,
            touched: true
        },
        ColliIDs: {
            elementType: 'multi-select',
            elementConfig: {
                type: 'multi-select',
                isMulti: true,
                closeMenuOnSelect: false,
                className: classes.validMessage,
                components: animatedComponents,
                isLoading: loading,
                name: 'Collies',
                label: translations['choose_colli'] || 'Choose colli ',
                options: data.storage,
                selected: [],
                margin: "dense",
                fullWidth: true,
            },
            formHelperText: translations['choose_colli'] || 'Choose colli :',
            value: [],
            validation: {
                required: true
            },
            valid: true,
            touched: true
        },
        UserIDs: {
            elementType: 'multi-select',
            elementConfig: {
                type: 'multi-select',
                isMulti: true,
                closeMenuOnSelect: false,
                components: animatedComponents,
                className: classes.validMessage,
                name: 'users',
                isLoading: loading,
                label: translations['choose_user'] || 'Choose users',
                options: data.users,
                selected: [],
                margin: "dense",
                fullWidth: true,
            },
            formHelperText: translations['choose_user'] || 'Choose users:',
            value: [],
            validation: {
                required: true
            },
            valid: true,
            touched: true
        }
    };

    return form;
}

const FilterReport = props => {
    const { classes, setDate, data, activeCustomer, onLoadReport, onGetColumns, load, date, translations } = props;
    const [filterForm, setFilterForm] = useState(updateFormStateOne(classes, data, activeCustomer, load, translations));
    const [filterFormValid, setFilterFormValid] = useState(false);

    useEffect(() => {
        setFilterForm(updateFormStateOne(classes, data, activeCustomer, load, translations));
    }, [classes, data, activeCustomer, load, translations]);

    const inputChangedHandler = (event, inputIdentifier) => {
        const updateState = formUtility.getNewStateOnInputChange(event, inputIdentifier, filterForm);
        setFilterForm(updateState.myForm);
    }
    const dateChangedHandler = (event, inputIdentifier) => {
        const updateState = formUtility.getNewStateOnDateChange(event, inputIdentifier, filterForm);
        setFilterForm(updateState.myForm);

        if (updateState.myForm.from.value > updateState.myForm.to.value || moment(updateState.myForm.from.value).isSameOrAfter(updateState.myForm.to.value)) {
            setFilterForm({ ...filterForm, to: { ...filterForm.to, value: moment(updateState.myForm.from.value).add('weeks').endOf('isoWeek') } })
        }
        if (inputIdentifier === 'from') {
            setFilterForm({ ...updateState.myForm, to: { ...updateState.myForm.to, elementConfig: { ...updateState.myForm.to.elementConfig, minDate: updateState.myForm.from.value }, from: { ...updateState.myForm.from, value: updateState.myForm.from.value } } })
        }

        if (!(moment(updateState.myForm.from.value, 'YYYY-DD-MM').isValid() && moment(updateState.myForm.to.value, 'YYYY-DD-MM').isValid())) {
            setFilterFormValid(true);
        }
        else {
            setFilterFormValid(moment(updateState.myForm.from.value).isSameOrAfter(updateState.myForm.to.value));
        }

    }
    const onMultiSelectChange = (ids, data, identifier) => {
        const updatedState = formUtility.getNewStateOnMultiSelectChange(ids, identifier, filterForm);
        setFilterForm(updatedState.myForm);
    };
    const submitHandler = async () => {
        const formData = formUtility.getFormData(filterForm);
        formData['from'] = moment(formData.from).format('YYYY-MM-DD');
        formData['to'] = moment(formData.to).format('YYYY-MM-DD');
        props.setLoad(true);
        onGetColumns({ ...date, dayStart: formData['from'], dayEnd: formData['to'] });
        await onLoadReport({ ...formData, ActiveCustomerID: activeCustomer });
        props.setLoad(false);
        setDate({ ...date, dayStart: formData['from'], dayEnd: formData['to'] });
    };

    return (
        <>
            <Form
                formIsValid={filterFormValid}
                classes={classes}
                form={filterForm}
                inputChangedHandler={inputChangedHandler}
                buttonTextCancel={translations['generate_report'] || "Generate Report"}
                cancelHandler={submitHandler}
                cancelButtonStyle={{ width: '100%', marginBottom: '10px', borderRadius: '1px', color: props.load || filterFormValid ? null : 'white' }}
                dateChangedHandler={dateChangedHandler}
                cancelButtonDisabled={props.load || filterFormValid}
                getMultiSelectData={onMultiSelectChange}
                cancelButtonColor={'primary'}
            />
        </>
    );
};

export default withStyles(styles, { withTheme: true })(FilterReport);